<template>
  <div>
    <div class="results-top-navigation">
      <div class="row relative">
        <div class="small-12 medium-6 large-6 columns">
          <div class="row">
            <div class="small-12 columns small-text-center graph-type-container-wrapper">
              <div class="graph-type-container">
                <a class="button" :class="{ 'active' : showingIncomeGraph }" @click.prevent="actionGraphType({ value: 'income' })">Income Graph</a>
                <a class="button" :class="{ 'active' : !showingIncomeGraph }" @click.prevent="actionGraphType({ value: 'balance' })">Balance Graph</a>
              </div>
            </div>
          </div>
        </div>

        <div class="small-12 medium-6 columns small-text-center breakdown-toggle" :class="{ 'open': showBreakdown }">
          <a @click="actionBreakdownShow({ value: false })" v-if="showBreakdown">Close breakdown <i class="fa fa-times-circle"></i></a>
          <a @click="actionBreakdownShow({ value: true })" v-else>See breakdown <i class="fa fa-plus-circle"></i></a>
        </div>

        <div class="small-12 medium-12 large-6 columns overflow-hidden">
          <transition name="fade-right">
            <div class="row" v-show="showBreakdown">
              <div class="small-3 large-3 columns breakdown breakdown-age">
                <div class="row">
                  <div class="medium-12 columns">Select age</div>
                </div>

                <div class="row">
                  <div class="medium-12 columns">
                    <div class="select-age-container">
                      <a href="#" class="button prefix" @click.prevent="incrementBreakdownAge(-1)">-</a>
                      <custom-input type="number" :property="ui.breakdown.age" @change="actionBreakdownAge($event.target.value)" :hideOverlay="true"></custom-input>
                      <a href="#" class="button postfix" @click.prevent="incrementBreakdownAge(1)">+</a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="small-9 columns breakdown breakdown-summary">
                <table class="breakdown-table" v-if="showingIncomeGraph">
                  <thead>
                    <tr>
                      <td></td>
                      <td>Age</td>
                      <td>Super</td>
                      <td>Age pension</td>
                      <td>Salary</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="who-heading">You</td>
                      <td>{{ breakdownAge }}</td>
                      <td class="you-super">
                        <i class="fa fa-circle" aria-hidden="true"></i> <span>$<animated-number :value="yourSuper" /></span>
                      </td>
                      <td class="you-pension">
                        <i class="fa fa-circle" aria-hidden="true"></i> <span>$<animated-number :value="yourPension" /></span>
                      </td>
                      <td class="you-salary">
                        <i class="fa fa-circle" aria-hidden="true"></i> <span>$<animated-number :value="yourSalary" /></span>
                      </td>
                    </tr>
                    <tr v-if="includePartner">
                      <td class="who-heading">Your partner</td>
                      <td>{{ breakdownPartnerAge }}</td>
                      <td class="partner-super">
                        <i class="fa fa-circle" aria-hidden="true"></i> <span>$<animated-number :value="yourPartnerSuper" /></span>
                      </td>
                      <td class="partner-pension">
                        <i class="fa fa-circle" aria-hidden="true"></i> <span>$<animated-number :value="yourPartnerPension" /></span>
                      </td>
                      <td class="partner-salary">
                        <i class="fa fa-circle" aria-hidden="true"></i> <span>$<animated-number :value="yourPartnerSalary" /></span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table class="breakdown-table" v-else>
                  <thead>
                    <tr>
                      <td></td>
                      <td>Age</td>
                      <td>Balance</td>
                      <td>Total</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="who-heading">You</td>
                      <td>{{ breakdownAge }}</td>
                      <td class="you-balance">
                        <i class="fa fa-circle" aria-hidden="true"></i> <span>$<animated-number :value="yourBalance" /></span>
                      </td>
                      <td class="you-total">
                        <span>$<animated-number :value="yourTotalBalanceAtBreakdownAge" /></span>
                      </td>
                    </tr>
                    <tr v-if="includePartner">
                      <td class="who-heading">Your Partner</td>
                      <td>{{ breakdownPartnerAge }}</td>
                      <td class="partner-balance">
                        <i class="fa fa-circle" aria-hidden="true"></i> <span>$<animated-number :value="yourPartnerBalance" /></span>
                      </td>
                      <td class="partner-total"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>

    <div class="chart-container">
      <div class="row">
        <div class="large-8 large-push-4 columns chart-holder">
          <chart></chart>
        </div>

        <div class="large-8 large-push-4 columns small-summary-display">
          <div class="income-gap-info">
            <div class="row target-income">
              <div class="small-8 small-push-4 columns target-income">
                <div class="text">Target retirement income</div> <div class="number">$<animated-number :value="inferred.TargetIncome.value" /></div>
              </div>
            </div>
            <div class="income-gap row" v-if="heights.shortFall !== 0" :style="{ height: heights.shortFall + 'px' }">
              <div class="small-4 columns bar">
                <div class="box"></div>
              </div>
              <div class="small-8 columns summary">
                <div class="text">Income gap</div> <div class="number">$<animated-number :value="yourIncomeShortfall" /></div>
              </div>
            </div>
            <div class="retirement-income row" :style="{ height: heights.income + 'px' }">
              <div class="small-4 columns bar">
                <div class="box"></div>
              </div>
              <div class="small-8 columns summary">
                <div class="text">Estimated annual retirement income</div> <div class="number">$<animated-number :value="yourIncomeAtRetirement" /></div>
              </div>
            </div>
          </div>
          <div class="row rotate-device-info">
            <div class="small-4 columns" v-html="rotateDevice"></div>
            <div class="small-8 columns">
              <p>Rotate your device to view the graph.</p>
            </div>
          </div>
        </div>

        <div class="large-4 large-pull-8 columns chart-sidebar">
          <div class="todays-dollars-notice key">The amounts shown are in today's dollars.</div>

          <table class="no-margin-bottom">
            <tbody>
              <tr>
                <td class="key">
                  <span class="you-super" v-if="!showBreakdown && !showingIncomeGraph"><i class="fa fa-circle" aria-hidden="true"></i></span>
                  Balance at retirement
                </td>
                <td class="value">$<animated-number :value="yourBalanceAtRetirement" /></td>
              </tr>
              <tr>
                <td class="key">Age you want super to last to</td>
                <td class="value"><animated-number :value="inputs.RunOutAge.value" /></td>
              </tr>
              <tr>
                <td colspan="2"><hr /></td>
              </tr>
              <tr>
                <td class="key">Desired annual income</td>
                <td class="value">$<animated-number :value="inferred.TargetIncome.value" /></td>
              </tr>
              <tr>
                <td class="key">
                  <span class="you-super" v-if="!showBreakdown && showingIncomeGraph"><i class="fa fa-circle" aria-hidden="true"></i></span>
                  Estimated annual income
                </td>
                <td class="value">$<animated-number :value="yourEstimatedIncome" /></td>
              </tr>
            </tbody>
          </table>

          <table>
            <tbody>
              <tr class="highlight">
                <td class="key">
                  <span class="income-gap"><i class="fa fa-circle" aria-hidden="true"></i></span>
                  Income gap
                </td>
                <td class="value">
                  <span class="align-middle">$<animated-number :value="yourIncomeShortfallOrZero" /></span>
                  <a class="icon relative" @click="toggleOverlay(true)">
                    <span id="questionBubblePosition"></span>
                    <span v-html="questionBubble"></span>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="footer-container">
      <div class="row footer-header">
        <div class="small-12 medium-6 columns">Explore your options</div>
        <div class="medium-6 columns show-for-medium">Edit what we know and other assumptions</div>
      </div>

      <div class="row footer-links">
        <div class="medium-8 columns left">
          <router-link :to="{ name: 'results.contributions' }" tag="button">Contributions</router-link>
          <router-link :to="{ name: 'results.investmentMix' }" tag="button">Investment mix</router-link>
          <router-link :to="{ name: 'results.careerBreak' }" tag="button">Career break</router-link>
          <router-link :to="{ name: 'results.retirement' }" tag="button">Retirement target</router-link>
          <router-link :to="{ name: 'results.agePension' }" tag="button">Age pension</router-link>
        </div>
        <div class="medium-4 columns right">
          <router-link :to="{ name: 'results.personal' }" tag="button">Personal Details</router-link>
          <router-link :to="{ name: 'results.super' }" tag="button">Your Current super</router-link>
          <router-link :to="{ name: 'results.assumptions' }" tag="button" class="full-width">Fees, Return, Insurance, Inflation</router-link>
        </div>
      </div>

      <div class="row footer-body">
        <div class="small-12 columns">
          <router-view :hide-nav="true"></router-view>
        </div>
      </div>

      <div class="row bottom-footer">
        <!-- <div class="small-12 medium-6 medium-push-6 columns footer-next-steps">
          <router-link :to="{ name: 'next-steps' }">Need more help to boost your super?</router-link>
        </div>
        <div class="small-12 medium-6 medium-pull-6 columns assumptions-link">
          <a href="https://qsuper.qld.gov.au/misc/disclaimer/calculator-disclaimer/" target="_blank">Disclaimer and assumptions</a> -
          <router-link :to="{ name: 'results.assumptions' }">Edit assumptions</router-link>
        </div> -->
      </div>
    </div>

    <div id="resultsOverlay" class="overlay" v-if="shouldShowOverlay">
      <div class="overlay-content">
        <div class="icon" v-html="overlayBubble"></div>

        <div class="row overlay-outside-content">
          <div class="small-12 columns">
            <h4>Estimated retirement income</h4>
            <p>You are on track to achieve an estimated lump sum of <span>$<animated-number :value="yourBalanceAtRetirement" /></span> in retirement, which could give you an estimated annual income of <span>$<animated-number :value="yourEstimatedIncome" /></span> to age {{ inputs.RunOutAge.value }}.</p>
          </div>
        </div>

        <div class="close">
          <a @click="toggleOverlay(false)">X</a>
        </div>

        <div class="row">
          <div class="small-12 columns">
            <div class="overlay-inside-content">
              <div class="row">
                <div class="small-12 medium-7 columns relative">
                  <div class="income-gap-info">
                    <div class="bar">
                      <div class="target-income">
                        <p class="small-line-height">Target retirement income <br /><span>$<animated-number :value="inputs.TargetIncome.value" /></span></p>
                      </div>
                      <div class="border"></div>

                      <div v-if="yourIncomeShortfall > 0">
                        <div class="gap" >Income Gap</div>
                        <div class="border"></div>
                      </div>

                      <div class="income"><p class="small-line-height">Estimated annual<br />retirement income <br /><span>$<animated-number :value="yourEstimatedIncome" /></span></p></div>
                    </div>
                  </div>

                  <div class="gap-info">
                    <p v-if="yourIncomeShortfall > 0">However this is <span>$<animated-number :value="yourIncomeShortfall" /></span> LESS per year than your target!</p>
                    <p v-else>Good news! Estimated income is greater than target.</p>
                  </div>
                </div>

                <div class="small-12 medium-5 columns">
                  <p class="overlay-side-text">See what you can do that may improve your retirement income by exploring your contributions, investment mix and career break options.</p>
                </div>
              </div>

              <div class="row">
                <div class="small-12 columns">
                  <strong class="figures">The amounts shown are in today's dollars.</strong>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="make-changes">
          <a class="button" @click="toggleOverlay(false)">Make changes&nbsp;&nbsp;&rarr;</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ramjet from 'ramjet';
import { mapState, mapActions } from 'vuex';
import ChartControl from '@/components/ChartControl.vue';

export default {
  components: {
    chart: ChartControl,
  },
  data() {
    return {
      totalHeight: 300,
      showOverlay: true,
      graphTypes: {
        income: {
          value: 'income',
          text: 'Income Graph',
        },
        balance: {
          value: 'balance',
          text: 'Balance Graph',
        },
      },
      overlayBubble: require('!html-loader!@/assets/overlay-icon.svg'),
      questionBubble: require('!html-loader!@/assets/question-bubble.svg'),
      rotateDevice: require('!html-loader!@/assets/rotate-device.svg'),
    };
  },
  computed: {
    ...mapState(['ui', 'inputs', 'inferred', 'results']),
    // This can probably be seperated
    heights() {
      let shortfallPercentage = this.yourIncomeShortfall / this.inferred.TargetIncome.value;

      if (shortfallPercentage < 0) {
        shortfallPercentage = 0;
      }

      let shortFallHeight = this.totalHeight * shortfallPercentage;
      let incomeHeight = this.totalHeight - shortFallHeight;

      const minShortFallHeight = 62;
      if (shortFallHeight > 0 && shortFallHeight < minShortFallHeight) {
        // resize bigger
        shortFallHeight = minShortFallHeight;
        incomeHeight = this.totalHeight - shortFallHeight;
      }

      const minIncomeHeight = 62;
      if (incomeHeight > 0 && incomeHeight < minIncomeHeight) {
        // resize bigger
        incomeHeight = minIncomeHeight;
        shortFallHeight = this.totalHeight - incomeHeight;
        if (shortFallHeight < minShortFallHeight) {
          shortFallHeight = minShortFallHeight;
        }
      }

      return {
        shortFall: shortFallHeight,
        income: incomeHeight,
      };
    },
    breakdownAge() {
      return this.ui.breakdown.age.value;
    },
    breakdownPartnerAge() {
      const yourAge = this.inputs.AgeNow.value;
      const partnerAge = this.inputs.AgeNow_2.value;
      const diff = yourAge - partnerAge;

      return this.breakdownAge - diff;
    },
    breakdownAgeIndex() {
      const min = this.showingIncomeGraph ? this.inputs.RetirementAge.value : this.inputs.AgeNow.value;
      const index = this.breakdownAge - min;
      return index;
    },
    yourBreakdownIndex() {
      return this.results.engineResults.subjectRetirementAgeIndex + this.breakdownAgeIndex;
    },
    yourSuper() {
      return this.results.engineResults.subjectOutput.deflatedDrawingsInYear[this.yourBreakdownIndex];
    },
    yourPension() {
      return this.results.engineResults.subjectOutput.deflatedAgePension[this.yourBreakdownIndex];
    },
    yourSalary() {
      return this.results.engineResults.subjectOutput.deflatedSalary[this.yourBreakdownIndex];
    },
    yourBalance() {
      return this.results.engineResults.subjectOutput.deflatedAssetsInYear[this.breakdownAgeIndex];
    },
    yourPartnerSuper() {
      return this.results.engineResults.partnerOutput.deflatedDrawingsInYear[this.yourBreakdownIndex];
    },
    yourPartnerPension() {
      return this.results.engineResults.partnerOutput.deflatedAgePension[this.yourBreakdownIndex];
    },
    yourPartnerSalary() {
      return this.results.engineResults.partnerOutput.deflatedSalary[this.yourBreakdownIndex];
    },
    yourPartnerBalance() {
      return this.results.engineResults.partnerOutput.deflatedAssetsInYear[this.breakdownAgeIndex];
    },
    yourTotalBalanceAtBreakdownAge() {
      return this.yourBalance + (this.includePartner ? this.yourPartnerBalance : 0);
    },
    // not breakdown properties
    yourIncomeShortfall() {
      return (this.yourEstimatedIncome - this.inferred.TargetIncome.value) * -1;
    },
    yourIncomeShortfallOrZero() {
      const shortFall = this.yourIncomeShortfall;
      return shortFall < 0 ? 0 : shortFall;
    },
    yourEstimatedIncome() {
      return this.results.targetIncome;
    },
    yourIncomeAtRetirement() {
      return this.results.deflatedCombinedIncomeAtRetirement;
    },
    yourBalanceAtRetirement() {
      return this.results.deflatedCombinedBalanceAtRetirement;
    },
    includePartner() {
      return this.inputs.IncludePartner.value;
    },
    showBreakdown() {
      return this.ui.breakdown.show.value;
    },
    shouldShowOverlay() {
      return this.showOverlay;
    },
    showingIncomeGraph() {
      return this.ui.graphType.value === 'income';
    },
  },
  methods: {
    ...mapActions([
      'actionGraphType',
      'actionBreakdownShow',
      'actionBreakdownAge',
    ]),
    incrementBreakdownAge(value) {
      this.actionBreakdownAge({ value: this.ui.breakdown.age.value + value });
    },
    toggleOverlay(show) {
      const questionBubble = document.getElementById('questionBubblePosition');
      const resultsOverlay = document.getElementById('resultsOverlay');

      if (!show) {
        ramjet.transform(resultsOverlay, questionBubble);
      }

      this.showOverlay = show;
    },
  },
};
</script>
